import React, { useMemo } from "react";
import { getCumulativeResult } from "data/Querys"
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import Status from "components/presentation/Status";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { useViewport } from 'components/general/useViewPort'
import { getRscObject } from "helpers/rsc";

import NotAvailable from 'components/common/NotAvailable'
import { TableColumnsTeams as ColumnsTeams } from 'components/sports/gar/events/teams/Columns'
import { TableExpandedTeams as TableExpanded } from 'components/sports/gar/events/teams/TableExpanded'
import { TableExpandedAllAround, TableExpandedAllAroundMobile } from 'components/sports/gar/events/allaround/TableExpanded'

import { useQuery } from 'react-query'
import Loader from 'components/general/Loader'
import { isStartListStatus, isFinishedStatus } from "helpers/status";
import Label from "components/general/Label"
import { EVENT } from "components/sports/gar/helper/GarHelpers";
import ProgressionRule from "components/common/ProgressionRule";
import { isLiveStatus } from "helpers/status";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const GarTeams = ({ event }) => {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    // const { breakPoint } = useViewport();
    const rscObj = getRscObject(mirs_rsc)
    const teamRsc = `${rscObj.discipline}${rscObj.sex}${event}${rscObj.phase}--------`
    // results data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['teamResults', mirs_competition, mirs_language, teamRsc],
            queryFn: getCumulativeResult,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable /> }
    if (isLoading) { return <Loader /> }
    //if (!data?.cumulativeResults?.results) { return <NotAvailable /> }

    return (<GARResultTeams data={data} event={event} />);
};

export default GarTeams;

export const GARResultTeams = ({ data, event }) => {
    const { breakPoint } = useViewport();
    const resultStatus = data?.cumulativeResults?.status?.code;
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)
    const configEvent = useMemo(() => getConfiguration(rscObj.sex, rscObj.phase, data, breakPoint), [resultStatus, breakPoint]);
    const rsc = `${rscObj.discipline}${rscObj.sex}${event}}${rscObj.phase}--------`



    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => {

        const isMobile = (breakPoint === "sm" || breakPoint === "xs")

        return (
            <LoaderSubComponent component={
                (event === EVENT.TEAM)
                    ? <TableExpanded row={row?.original} gender={rscObj.sex} />/*Team Results*/
                    /*All Around*/
                    : isMobile ? <TableExpandedAllAroundMobile row={row?.original} gender={rscObj.sex} /> : <TableExpandedAllAround row={row?.original} gender={rscObj.sex} />
            } />
        )

        // eslint-disable-next-line
    }, [resultStatus, breakPoint]);

    let swQualRules = (rscObj.phase.indexOf("QUAL") > -1) ? true : undefined

    let noData = []
    let dataRow = data?.cumulativeResults?.results ? data?.cumulativeResults?.results : noData


    return (
        <>
            {swQualRules &&
                <ProgressionRule
                    key="progress-component"
                    data={data?.config}
                    filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                />}


            <MirsTable
                //Dato to show by row
                data={dataRow}
                //Columnas a visualizar 
                columns={configEvent.columns}
                //subcomponente a renderizar, extended
                renderRowSubComponent={renderRowSubComponent}
                //Key by row necesary in order to no paint innecesary
                keyRow='participant-code'
                //Component caption
                caption={configEvent.caption}
                //Columns to hidde 
                hiddenColumns={configEvent.hiddenColumns}
                //When show tble is sorted by 
                initialSortBy={configEvent.sortBy}
                id={`mirs-table-team-result-${rsc}`}
                getRowProps={row => {
                    let isCurrent = Array.isArray(row.original?.extendedResultsCurrent) &&
                        row.original?.extendedResultsCurrent?.find(item =>
                            item.er_code === 'STAGE' &&
                            item.er_type === 'ER' &&
                            item.er_value === "LAST") &&
                        row.original?.extendedResultsCurrent.length > 0
                    return {
                        className: isCurrent ? 'currentIndicator' : '',
                    }
                }}
                classCaption={isLiveStatus(resultStatus) ? 'currentIndicator' : ''}
            />
        </>
    )
}

const getConfiguration = (gender, phase, data, breakPoint) => {
    const columnsAdded = [];
    const resultStatus = data?.cumulativeResults?.status?.code
    const scheduleStatus = data?.results?.schedule?.status?.code;
    const subdivision = data?.cumulativeResults?.extendedInfos?.find(ei => ei?.ei_code === 'SUBDIVISION')?.ei_value;
    const rotation = data?.cumulativeResults?.extendedInfos?.find(ei => ei?.ei_code === 'ROTATION')?.ei_value;
    const captionLeftLive = rotation && subdivision ? <><Label data="HeaderRotation" />{`: ${subdivision}/${rotation}`}</> : ''
    const captionLeftNotLive = subdivision ? <><Label data="LabelAfterSubdivision" />{` ${subdivision}`}</> : ''
    const captionLeft = resultStatus === 'LIVE' ? captionLeftLive : isFinishedStatus(resultStatus) ? '' : captionLeftNotLive;

    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartListStatus(resultStatus),
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    configuration.caption = <CaptionTable
        leftCol={<h4 className="text-dark">{captionLeft}</h4>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartListStatus(resultStatus)
        ? [{ id: 'Rank', desc: false }]
        : [{ id: 'Rank', desc: false }]

    configuration.columns = ColumnsTeams(gender, phase, breakPoint);
    return configuration;
};

// BB Balance Beam
// FX Floor Exercise
// HB Horizontal Bar
// PB Parallel Bars
// PH Pommel Horse
// SR Rings
// UB Uneven Bars
// VT Vault

//Women
    //VT
    //UB
    //BB
    //FX

//Men
    //FX
    //PH
    //SR
    //VT
    //PB
    //HB

